<template>
  <div class="fixed w-full h-full flex justify-center items-center bg-overlay z-50 top-0 left-0">
    <div class="relative flex flex-col w-[1136px] h-fit rounded bg-white overflow-hidden">
      <!-- intro -->
      <div class="relative flex flex-row justify-start p-[54px] bg-primary-700">
        <!-- close btn -->
        <button
            class="absolute left-[25px] top-[27px] w-9 h-9 rounded flex justify-center items-center text-white"
            @click="handleClose"
        >
          <span class="material-symbols-rounded">close</span>
        </button>
        <!-- sale title -->
        <div class="flex flex-row items-center gap-[20px]">
          <div
              class="flex justify-center items-center h-[40px] w-[40px] bg-complementary-600 text-complementary-900 rounded-full">
            <span class="material-symbols-rounded">storefront</span>
          </div>

          <div class="flex flex-col gap-[4px]">
            <h2 class="text-white text-2xl font-medium">תבחרו איפה נח לכם</h2>
            <p class="text-purple_semantic text-base font-regular">
              <span class="font-medium">זו התחנה שלכם :</span>
              {{ currentStation.name }}, {{ currentStation.g_address }}, {{ currentStation.address_description }},
              {{ currentStation.orders_end_day }}
            </p>
          </div>

        </div>
      </div>
      <!-- content -->
      <div class="flex flex-col gap-[42px] min-h-[300px] pl-[29px] pr-[54px] pt-[46px] pb-[25px]">
        <station-address-form/>
        <div class="w-full xl:h-[300px] 2xl:h-[523px]  pl-[10px] overflow-y-auto custom-scroll-bar">
          <div class="flex-wrap gap-[27px] grid grid-cols-3">
            <station
                v-for="station in stations"
                :key="station.name"
                :selectedStation="selectedStation"
                :station="station"
                @station-selected="handleStationSelection"
            />
          </div>
        </div>
      </div>

      <!-- action -->
      <div class="flex flex-row justify-end gap-[24px] pt-[52px] pb-[32px] pl-[43px] border-t border-grays-400 ">
        <check-box v-model="accepted">
          <slot>
            חשוב! התחנה הזו עוברת דירה החל מהמכירה הבאה פרשת ויקהל - בתאריך 17.3.23
          </slot>
        </check-box>
        <button-primary
            :disabled="!selectedStation || !accepted"
            @click="handleChangeStation"
        >
          רוצים לשנות תחנה
        </button-primary>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex"
import StationAddressForm from "@/components/Global/StationAddressForm.vue";
import Station from "@/components/Global/Station.vue";
import CheckBox from "@/components/Global/CheckBox.vue";
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import axiosInstance from "@/helpers/axios";

export default {
  name: "change-station-modal",
  components: {ButtonPrimary, CheckBox, Station, StationAddressForm},
  data() {
    return {
      accepted: false,
      selectedStation: "",
    };
  },
  props: {
    currentStation: {
      type: Object,
      required: true,
    }
  },
  methods: {
    handleStationSelection(street) {
      this.selectedStation = street;
    },
    async handleChangeStation() {
      try {
        await axiosInstance.put('/clients', {
          siteID: this.currentStation.id
        });
      } catch (error) {
        console.error(error);
      }
      this.$emit("toggle-modal")
    },
    handleClose() {
      document.body.classList.remove("body-scroll-hidden");
      this.$emit("toggle-modal")
    },
  },
  computed: {
    ...mapState({
      stations: state => state.findStation.stations,
    }),
  },
  mounted() {
    document.body.classList.add("body-scroll-hidden");

  }
}
</script>

<style>

</style>